
import { gsap } from "gsap"
import { mousePos, colors } from "./bundle"

class CustomCursor{
    constructor(){
        this.mouseCursorCenter = document.getElementById('customCursorCenter')
        this.mouseCursorCenterFill = this.mouseCursorCenter.querySelector('.customCursorCenter__fill')
        this.mouseCursorRing = document.getElementById('customCursorRing')
        this.header = document.querySelector('header')
        window.addEventListener('mousemove', () => {
            gsap.set(this.mouseCursorCenter,{
                x: mousePos.x,
                y: mousePos.y
            })
            gsap.to(this.mouseCursorRing,{
                duration: 0.5,
                x: mousePos.x,
                y: mousePos.y,
                ease: 'power2.out'
            })
        })
    }


    setCustomCursor(nextContainer){
        // this.mouseCursorCenter.classList.remove('discover-element')
        // if(nextContainer.querySelector('.page-shop-wall') !== null){
        //     const cursorElements = [...nextContainer.querySelectorAll('.product')]
        //     cursorElements.forEach(cursorElement => {
        //         cursorElement.addEventListener('mousemove',() => {
        //             if(cursorElement.classList.contains('current') && !document.body.classList.contains('is-mouse-down')){
        //                 this.mouseCursorCenter.classList.add('discover-element')
        //             }
        //             else{
        //                 this.mouseCursorCenter.classList.remove('discover-element')
        //             }
        //         })
        //         cursorElement.addEventListener('mouseenter',() => {
        //             if(cursorElement.classList.contains('current') && !document.body.classList.contains('is-mouse-down')){
        //                 this.mouseCursorCenter.classList.add('discover-element')
        //             }
        //             else{    
        //                 this.mouseCursorCenter.classList.remove('discover-element')
        //             }
        //         })
        //         cursorElement.addEventListener('mouseleave',() => {
        //             if(cursorElement.classList.contains('current')){
        //                 this.mouseCursorCenter.classList.remove('discover-element')
        //             }
        //         })
        //     }) 

        // }
        // if(nextContainer.querySelectorAll('.link-element') !== null){
        //     const linkElements = [...nextContainer.querySelectorAll('.link-element')]
        //     linkElements.forEach(linkElement => {
        //         linkElement.addEventListener('mousemove',() => {
        //             if(!document.body.classList.contains('is-mouse-down')){
        //                 this.mouseCursorCenter.classList.add('link-element')
        //             }
        //             else{
        //                 this.mouseCursorCenter.classList.remove('link-element')
        //             }
        //         })
        //         linkElement.addEventListener('mouseenter',() => {
        //             if(!document.body.classList.contains('is-mouse-down')){
        //                 this.mouseCursorCenter.classList.add('link-element')
        //             }
        //             else{    
        //                 this.mouseCursorCenter.classList.remove('link-element')
        //             }
        //         })
        //         linkElement.addEventListener('mouseleave',() => {
        //             this.mouseCursorCenter.classList.remove('link-element')
                    
        //         })
        //     }) 
        // }
        // if(this.header.querySelectorAll('.link-element') !== null){
        //     const linkElements = [...this.header.querySelectorAll('.link-element')]
        //     linkElements.forEach(linkElement => {
        //         linkElement.addEventListener('mousemove',() => {
        //                 gsap.to(this.mouseCursorCenter, {
        //                     duration: 0.3,
        //                     scale: 1.2
        //                 })
        //                 this.mouseCursorCenter.classList.add('link-element')
        //             // if(!document.body.classList.contains('is-mouse-down')){
        //             //     this.mouseCursorCenter.classList.add('link-element')
        //             // }
        //             // else{
        //             //     this.mouseCursorCenter.classList.remove('link-element')
        //             // }
        //         })
        //         linkElement.addEventListener('mouseenter',() => {
        //             // if(!document.body.classList.contains('is-mouse-down')){
        //             //     this.mouseCursorCenter.classList.add('link-element')
        //             // }
        //             // else{    
        //             //     this.mouseCursorCenter.classList.remove('link-element')
        //             // }
        //         })
        //         linkElement.addEventListener('mouseleave',() => {
        //             // this.mouseCursorCenter.classList.remove('link-element')
                    
        //         })
        //     }) 
        // }
        if(document.querySelectorAll('.cursor-background-white') !== null){
            const cursorBackgroundElements = [...document.querySelectorAll('.cursor-background-white')]
            cursorBackgroundElements.forEach(cursorBackgroundElement => {
                cursorBackgroundElement.addEventListener('mousemove',() => {
                    this.mouseCursorCenter.classList.add('white')
                    this.mouseCursorCenterFill.classList.add('white')
                })
                cursorBackgroundElement.addEventListener('mouseenter',() => {
                    this.mouseCursorCenter.classList.add('white')
                    this.mouseCursorCenterFill.classList.add('white')
                })
                cursorBackgroundElement.addEventListener('mouseleave',() => {
                    this.mouseCursorCenter.classList.remove('white')
                    this.mouseCursorCenterFill.classList.remove('white')
                })
            }) 

        }
        if(document.querySelectorAll('.cursor-element') !== null){
            const cursorElements = [...document.querySelectorAll('.cursor-element')]
            cursorElements.forEach(cursorElement => {
                cursorElement.addEventListener('mousemove',() => {
                    if(cursorElement.classList.contains('current')) return
                    gsap.to(this.mouseCursorCenter, {
                        duration: 0.3,
                        scale: 2
                    })
                    gsap.to(this.mouseCursorCenterFill, {
                        duration: 0.3,
                        opacity: 0
                    })
                })
                cursorElement.addEventListener('mouseenter',() => {
                    if(cursorElement.classList.contains('current')) return
                    gsap.to(this.mouseCursorCenter, {
                        duration: 0.3,
                        scale: 2
                    })
                    gsap.to(this.mouseCursorCenterFill, {
                        duration: 0.3,
                        opacity: 0
                    })
                })
                cursorElement.addEventListener('mouseleave',() => {
                    gsap.to(this.mouseCursorCenter, {
                        duration: 0.3,
                        scale: 1
                    })
                    gsap.to(this.mouseCursorCenterFill, {
                        duration: 0.3,
                        opacity: 1
                    })
                    
                })
            }) 
        }
    }

}

export {CustomCursor}